<template>
<div>{{project_id}}</div>
</template>

<script>
export default {
name: "Project",
  computed: {
    project_id() {
       return this.$route.params.project_id
    },
  },
  async mounted () {
    this.$store.commit('user/set_current_project_id', this.project_id);
    await this.$store.dispatch('setting/all');
    const simple = this.$store.getters['setting/get_setting']('simple_mode');
    if (simple) {
      this.$router.push({name: 'SimpleMode'});
    } else {
      this.$router.push({name: 'ProjectOverview'});
    }
  }
}
</script>

<style scoped>

</style>
